import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
export const filespaceSettingsResponseSchema = z.object({
    restrictWebAccess: z.boolean(),
    restrictMobileAccess: z.boolean(),
});
export class FilespaceSettingsResponseDto extends createZodDto(filespaceSettingsResponseSchema) {
}
